import React, { ReactElement } from "react";
import { Grid, Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  OuterContainer,
  Container,
  Background,
  IconContainer,
  ContentContainer,
  MainInfo,
  Description,
  Title,
} from "./styles";
import { OpenCircleIcon } from "../../../../assets/icons";
interface Props {
  title?: string;
  mainInfo?: string;
  description?: string;
  Icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  IconStyle?: React.SVGAttributes<SVGElement>;
  titleStyle?: React.CSSProperties;
  descriptionStyle?: React.CSSProperties;
  loading?: boolean;
  animateIcon?: boolean;
}

const CircleAndIconContainer = ({
  title,
  mainInfo,
  description,
  Icon,
  IconStyle,
  titleStyle,
  descriptionStyle,
  loading,
  animateIcon,
}: Props) => {
  const theme = useTheme();
  return (
    <OuterContainer>
      <Title style={{ ...titleStyle }}>{title}</Title>
      <Container>
        <Background>
          <OpenCircleIcon />
          <IconContainer animate={animateIcon}>
            <Icon
              {...IconStyle}
              width={IconStyle?.width ?? "100%"}
              height={IconStyle?.height ?? "100%"}
            />
            {/* <ClockIcon width={"100%"} height={"100%"} color={theme.palette.error.light} /> */}
          </IconContainer>
        </Background>
        <ContentContainer>
          {loading ? (
            <Grid style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
              <Skeleton
                variant="rounded"
                width="40px"
              />
              <Skeleton
                variant="rounded"
                width="40px"
              />
            </Grid>
          ) : (
            <React.Fragment>
              <MainInfo variant="h5">{mainInfo}</MainInfo>
              <Description
                variant="body2"
                style={{ ...descriptionStyle }}
              >
                {description}
              </Description>
            </React.Fragment>
          )}
        </ContentContainer>
      </Container>
    </OuterContainer>
  );
};

export default CircleAndIconContainer;
